/**
 * The page's motion style as the surface carries it: one attribute, `data-studio-motion`, on the
 * surface's root, and the Studio tokens under it pick every entrance's keyframes, durations and
 * delays (`tokens/studio.css`). No component branches on the style.
 *
 * Reduced motion always wins: a filler who asked their device for less movement gets `still`,
 * whatever the trainer chose — and `base.css` collapses whatever CSS motion is left besides.
 */

import type { StudioMotionStyle } from './appearance';

export function studioMotion(style: StudioMotionStyle, reducedMotion: boolean): StudioMotionStyle {
  return reducedMotion ? 'still' : style;
}
